import { LogLevel } from "@loglayer/shared";

//#region src/types.ts
/**
* List of plugin callbacks that can be called by the plugin manager.
*
* @see {@link https://loglayer.dev/plugins/creating-plugins.html#onbeforedataout | onBeforeDataOut Docs}
* @see {@link https://loglayer.dev/plugins/creating-plugins.html#shouldsendtologger | shouldSendToLogger Docs}
* @see {@link https://loglayer.dev/plugins/creating-plugins.html#onmetadatacalled | onMetadataCalled Docs}
* @see {@link https://loglayer.dev/plugins/creating-plugins.html#onbeforemessageout | onBeforeMessageOut Docs}
* @see {@link https://loglayer.dev/plugins/creating-plugins.html#oncontextcalled | onContextCalled Docs}
*/
let PluginCallbackType = /* @__PURE__ */ function(PluginCallbackType$1) {
	PluginCallbackType$1["onBeforeDataOut"] = "onBeforeDataOut";
	PluginCallbackType$1["shouldSendToLogger"] = "shouldSendToLogger";
	PluginCallbackType$1["onMetadataCalled"] = "onMetadataCalled";
	PluginCallbackType$1["onBeforeMessageOut"] = "onBeforeMessageOut";
	PluginCallbackType$1["onContextCalled"] = "onContextCalled";
	return PluginCallbackType$1;
}({});

//#endregion
export { LogLevel, PluginCallbackType };